import { useEffect, useRef, useState } from "react";
import Table from "../../components/GTable/Table";
import Button from "../../components/GButton/Button";
import DeleteRecord from "../../ui/Models/deleteRecord";
import Pagination from "../../ui/paginations/Paginations";
import TableSkeleton from "../../ui/sharedUi/tableSkeleton";
import i18n from "../../lib/i18n";
import { deleteBannersForm } from "../../lib/actions";
import { devices, marketingColumns, marketingPromotionPosition } from "../../lib/definitions";
import { GetMarketingPromotionsData } from "../../lib/data";

export default function MarketingPromotions() {

    const deleteRef = useRef(null);
    const [marketingPromotions, setMarketingPromotions] = useState([]);
    const [currentPage, setcurrentPage] = useState(1);
    const [last_page, setlast_page] = useState(1);
    const [deleteConfirmation, setDeleteConfirmation] = useState({ isOpen: false, idToDelete: null });
    const [isLoading, setIsLoading] = useState(true);  
    const [loadingDelete, setLoadingDelete] = useState(false);  
    const t = i18n.t.bind(i18n); 

    useEffect(() => {
        handleApi();
    }, [currentPage])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
            deleteRef.current && 
            !deleteRef.current.contains(event.target)
            ) {
            closeDeleteConfirmation();
            }
        };

        if (deleteConfirmation.isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [deleteConfirmation.isOpen]);

    const handleApi = async () => {
        setIsLoading(true); 
        const marketingPromotionData = await GetMarketingPromotionsData(currentPage);

        const transformedData = marketingPromotionData.data.map((item) => ({
            ...item,
            positions: item.positions
            ?.map((posId) => marketingPromotionPosition.find((p) => p.id === posId)?.name)
            .filter(Boolean)
            .join(", "),

            devices: item.devices
            ?.map((devId) => devices.find((d) => d.id === devId)?.name)
            .filter(Boolean)
            .join(", "),
        }));
        
        setMarketingPromotions([]);
        setcurrentPage(marketingPromotionData.pagination.current_page);
        setlast_page(marketingPromotionData.pagination.last_page);
        setMarketingPromotions(transformedData);
        setIsLoading(false);  
    };

    const handlePageChange = (page) => {
        setcurrentPage(page);
    };

    const openDeleteConfirmation = (id) => {
        setDeleteConfirmation({ isOpen: true, idToDelete: id });
    };

    const closeDeleteConfirmation = () => {
        setDeleteConfirmation({ isOpen: false, idToDelete: null });
    };

    const handelDelete = async () => {
        if (deleteConfirmation.idToDelete) {
            setLoadingDelete(true);
            const result = await deleteBannersForm(deleteConfirmation.idToDelete);
            if (result) {
                setLoadingDelete(false);
                handleApi();
            }
            closeDeleteConfirmation();
        }
    };

    return (
        <div className="p-8 sm:p-6 md:p-8">
            <div className="flex flex-col sm:flex-row sm:items-baseline border-t border-gray-500/100 bg-thirdly  justify-between px-5 py-5  gap-4">
                <h1 className="text-white text-lg ">{t("nav.marketing")}</h1>
                <Button background="#D36300" borderRadius="8px" color="white" padding="8px 20px" text={t("nav.add_marketing")} nav={"/marketingPromotion/add"}  />
            </div>
            <div>
                {isLoading ? <TableSkeleton cols={marketingColumns}/> : (  
                    <Table columns={marketingColumns} rows={marketingPromotions} openDeleteConfirmation={openDeleteConfirmation} edit="/marketingPromotion/edit" />
                )}
            </div>
            <div className="flex justify-center items-center py-5">
                <Pagination currentPage={currentPage} totalPages={last_page} handleChangePage={handlePageChange} />
            </div>
            {deleteConfirmation.isOpen && <DeleteRecord ref={deleteRef} loadingDelete={loadingDelete} handelDelete={handelDelete} closeDeleteConfirmation={closeDeleteConfirmation} />}
        </div>
    );
};